'use strict';

angular.module('ClinicApp').directive('appointmentSlotPicker', function() {
  return {
    templateUrl: '/views/directives/_appointment-slot-picker.html',
    scope: {
      appointment: '=',
      rescheduleFlowFeature: '=',
      timeSlots: '=',
      showTimeSlotError: '=',
    },
    link: function($scope) {

      $scope.$watch('appointment', function() {
        if ($scope.appointment) {
          var hasSentSlots = !!$scope.appointment.rescheduleSlotOptions;
          if (hasSentSlots == $scope.slotPickerOpen) {
            $scope.slotPickerOpen = !$scope.appointment.rescheduleSlotOptions;
            clearSlotData();
          }
        }
      });

      function clearSlotData() {
        $scope.timeSlots.slots = [{
          date: '',
          time: $scope.times[0],
        }, {
          date: '',
          time: $scope.times[0],
        }, {
          date: '',
          time: $scope.times[0],
        }];
      }

      $scope.slotPickerOpen = !$scope.appointment.rescheduleSlotOptions; // Open if practice has not sent slots.

      $scope.toggleTimeSlotPicker = function() {
        $scope.slotPickerOpen = !$scope.slotPickerOpen;
      };

      var hours = ['12', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'];
      var minutes = ['00', '15', '30', '45'];
      var meridians = ['AM', 'PM'];

      function generateTimes() {
        var times = [];
        for (var h = 0; h < meridians.length; h++) {
          for (var i = 0; i < hours.length; i++) {
            if (meridians[h] === 'AM' && (6 >= parseInt(hours[i]) || parseInt(hours[i]) === 12)) {
              continue;
            }
            if (meridians[h] === 'PM' && (10 <= parseInt(hours[i]) && parseInt(hours[i]) !== 12)) {
              continue;
            }
            for (var j = 0; j < minutes.length; j++) {
              times.push({
                label: hours[i] + ':' + minutes[j] + ' ' + meridians[h],
                value: i * 60 + j * 15 + (h === 1 ? 720 : 0), // hh:mm:pm? -> minutes past midnight, plus PM
              });
            }
          }
        }
        return times;
      }

      $scope.times = generateTimes();

      $scope.timeSlots = {
        slots: [{
          date: '',
          time: $scope.times[0],
        }, {
          date: '',
          time: $scope.times[0],
        }, {
          date: '',
          time: $scope.times[0],
        }],

        hasValidSlots: function() {
          return $scope.timeSlots.allSlotsFilled() && !$scope.timeSlots.areAnyTimeSlotsEqual();
        },

        allSlotsFilled: function() {
          return !_.some($scope.timeSlots.slots, function(timeSlot) {
            return timeSlot.date === '';
          });
        },

        anySlotsFilled: function() {
          var x = _.some($scope.timeSlots.slots, function(timeSlot) {
            return timeSlot.date !== '';
          });
          return x;
        },

        areAnyTimeSlotsEqual: function() {

          var slots = $scope.timeSlots.slots;
          for (var x = 0; x < slots.length; x++) {
            for (var y = 0; y < slots.length; y++) {
              if (x !== y && slots[x].date === slots[y].date && slots[x].time === slots[y].time && slots[x].date !== '') {
                return true;
              }
            }
          }

          return false;
        },

        numSlotsFilled: function() {
          return _.filter($scope.timeSlots.slots, function(timeSlot) {
            return timeSlot.date !== '';
          }).length;
        },

        getFormattedTimeSlots: function() {
          return _.chain($scope.timeSlots.slots).map(function(timeSlot) {
            var formattedDate = moment(timeSlot.date).format('YYYY-MM-DD');
            var timeAsMinutes = timeSlot.time.value;
            if (formattedDate === 'Invalid date') {
              return;
            }

            return {
              date: formattedDate,
              time: timeAsMinutes,
            };
          })
            .compact()
            .value();
        },
      };
    },
  };
});
